import { render, staticRenderFns } from "./ItemListAudio.vue?vue&type=template&id=2c71187b"
import script from "./ItemListAudio.vue?vue&type=script&lang=js"
export * from "./ItemListAudio.vue?vue&type=script&lang=js"
import style0 from "./ItemListAudio.vue?vue&type=style&index=0&id=2c71187b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports